import DocumentTitle from "react-document-title";

import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';


export function OrderNotFound(){
    return(
        <DocumentTitle title='Adamo'>
            <Container className="justify-content-md-center p-2 bg-light border">
                <Image src="images/adamo_logo.png" rounded></Image> <br/> <br/>
                <p className="text-start">Sajnáljuk, nem találjuk a regisztrációját! Kérjük vigye fel az adatait a regisztrációs lapon és új linket küldünk Önnek.</p>
                <p className="text-start">Ezt az oldalt most nyugodtan bezárhatja.</p>
                <br/>
                <p className="text-end fw-bold">Az Adamo csapata</p>
            </Container>
        </DocumentTitle>
    )
}
